import type { StatusMap } from '~/types';

export const documentStatusMap: StatusMap = {
  ARCHIVED: {
    icon: 'Close',
    theme: 'danger'
  },
  CREATED: {
    icon: 'Clock',
    theme: 'warning'
  },
  PENDING_CREATION: {
    icon: 'Clock',
    theme: 'warning'
  },
  PENDING_VERIFICATION: {
    icon: 'Clock',
    theme: 'warning'
  },
  REJECTED: {
    icon: 'Close',
    theme: 'danger'
  },
  UNDER_VERIFICATION: {
    icon: 'Clock',
    theme: 'warning'
  },
  VALIDATION_NOT_REQUIRED: {
    icon: 'Check',
    theme: 'success'
  },
  VERIFIED: {
    icon: 'Check',
    theme: 'success'
  }
};
